import { Controller } from "@hotwired/stimulus"

// Поиск по списку с debounce 300ms.
// Использование:
//   <div data-controller="dae20--searchable-list">
//     <input type="search" data-action="input->dae20--searchable-list#filter" placeholder="Поиск...">
//     <div data-dae20--searchable-list-target="itemsContainer">
//       <div data-search-key="GLM-4.7 free">...</div>
//     </div>
//   </div>
export default class extends Controller {
  static targets = ["itemsContainer"]
  static values = {
    delay: { type: Number, default: 300 },
    emptyMessage: { type: String, default: "Ничего не найдено" }
  }

  connect() {
    this.debounceTimer = null
    this.emptyEl = null
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  filter(event) {
    const query = (event.target.value || "").toLowerCase().trim()

    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.performFilter(query), this.delayValue)
  }

  toggleEmptyState(show) {
    if (show) {
      if (!this.emptyEl) {
        this.emptyEl = document.createElement("div")
        this.emptyEl.className = "rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center text-sm text-slate-500"
        this.emptyEl.textContent = this.emptyMessageValue
        this.itemsContainerTarget.appendChild(this.emptyEl)
      }
      this.emptyEl.classList.remove("hidden")
    } else if (this.emptyEl) {
      this.emptyEl.classList.add("hidden")
    }
  }

  clearFilter() {
    const input = this.element.querySelector('input[type="search"]')
    if (input) {
      input.value = ""
      input.dispatchEvent(new Event("input"))
    }
    this.clearTagFilter()
  }

  filterByTag(event) {
    this._activeTag = event.currentTarget.dataset.tagPrefix
    this.performFilter(this.currentQuery || "")
    this.highlightTagButton(event.currentTarget)
  }

  clearTagFilter() {
    this._activeTag = null
    this.performFilter(this.currentQuery || "")
    this.element.querySelectorAll("[data-tag-button]").forEach((btn) => {
      btn.classList.remove("border-indigo-300", "bg-indigo-50", "text-indigo-700")
      btn.classList.add("border-slate-200", "text-slate-600")
    })
  }

  highlightTagButton(activeBtn) {
    this.element.querySelectorAll("[data-tag-button]").forEach((btn) => {
      const isActive = btn === activeBtn
      btn.classList.toggle("border-indigo-300", isActive)
      btn.classList.toggle("bg-indigo-50", isActive)
      btn.classList.toggle("text-indigo-700", isActive)
      btn.classList.toggle("border-slate-200", !isActive)
      btn.classList.toggle("text-slate-600", !isActive)
    })
  }

  get currentQuery() {
    const input = this.element.querySelector('input[type="search"]')
    return input ? input.value.toLowerCase().trim() : ""
  }

  performFilter(query) {
    const items = this.itemsContainerTarget.querySelectorAll("[data-search-key]")
    let visibleCount = 0
    const tag = this._activeTag

    items.forEach((item) => {
      const key = (item.dataset.searchKey || "").toLowerCase()
      const itemTag = item.dataset.tagPrefix || ""
      const matchQuery = query === "" || key.includes(query)
      const matchTag = !tag || itemTag === tag
      const match = matchQuery && matchTag
      item.classList.toggle("hidden", !match)
      if (match) visibleCount++
    })

    this.toggleEmptyState(visibleCount === 0 && items.length > 0)
    this.dispatch("filtered", { detail: { visibleCount, query, tag } })
  }
}
